/**
 * scripts-components-announcement-bar.js
 * -----------------------------------------------------------------------
 * `<am-announcement-bar>`: subtle cross-fade rotation between multiple
 * announcement blocks. No-ops entirely (shows the first slide only) when
 * there's a single slide or the visitor prefers reduced motion.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';

  class AmAnnouncementBarElement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      if (!this.slides.length) return;

      this.index = 0;
      this.slides[0].classList.add('is-active');

      if (this.slides.length <= 1) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      var interval = parseInt(this.getAttribute('data-interval'), 10) || 5000;
      this._timer = setInterval(this._showNext.bind(this), interval);
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }

    _showNext() {
      this.slides[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
    }
  }

  if (!customElements.get('am-announcement-bar')) {
    customElements.define('am-announcement-bar', AmAnnouncementBarElement);
  }
})();
